module.exports = "<div class=\"close\" ng-click=\"cancel()\">+</div>\n\n<h2>Invite Friends</h2>\n\n<p>Send a friend Tablelist credit from web or mobile. After they sign up and book their first table or table package you get credit to.\n\n<img ng-src=\"https://assets.tablelist.com/www/assets/earn-credit-device-preview.jpg\" alt=\"You can find your referral code from your account on the website, and mobile apps.\"/>\n\n<p class=\"small\">Send invites from our iOS, Android, and web platforms.*</p>";


//////////////////
// WEBPACK FOOTER
// ./src/services/modal/earnCredit/earnCreditModal.html
// module id = 874
// module chunks = 1